import { type HcpVerificationIntercomStatus } from '../../contracts';

import {
  type HcpVerificationState,
  resolveHcpVerificationState,
} from './hcp-verification-state';
import { useQueryHcpVerifications } from './use-query-hcp-verifications';

/**
 * Unset while loading or ineligible — which includes a failed status read — so
 * Intercom keeps the stored value instead of losing it on a bad boot.
 */
export const HCP_VERIFICATION_INTERCOM_STATUS: Record<
  HcpVerificationState,
  HcpVerificationIntercomStatus | undefined
> = {
  unverified: 'unverified',
  pending_review: 'pending_review',
  verified: 'verified',
  rejected: 'rejected',
  loading: undefined,
  ineligible: undefined,
};

/**
 * The status the auth wrappers send Intercom. It observes the read the badge
 * probe issues rather than issuing one, so identify never triggers the
 * backend's daily reminder inmail.
 */
export function useHcpVerificationIntercomStatus():
  | HcpVerificationIntercomStatus
  | undefined {
  const query = useQueryHcpVerifications({ observeOnly: true });

  return HCP_VERIFICATION_INTERCOM_STATUS[
    resolveHcpVerificationState({
      isEnabled: query.isEnabled,
      isPending: query.isPending,
      isError: query.isError,
      status: query.data,
    })
  ];
}
